import { channelMeta } from "./journeyChannels";

const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];
export const monthName = (m) => MONTHS[parseInt(m.split("-")[1], 10) - 1];

const identity = (c) => (c.custom ? `${c.channel}:${(c.name || "").trim().toLowerCase()}` : c.key);
const plural = (n, word) => `${n} ${word}${n === 1 ? "" : "s"}`;

// Campaigns appearing for the first time in each charted month (first month skipped)
export const computeLaunches = (series, months) => {
  const seen = new Set();
  const out = {};
  const firstCharted = series[0]?.month;
  for (const m of Object.keys(months).sort()) {
    const visible = (months[m] || []).filter((c) => !c.hidden);
    const fresh = visible.filter((c) => !seen.has(identity(c)));
    visible.forEach((c) => seen.add(identity(c)));
    if (m > firstCharted && fresh.length && series.some((r) => r.month === m)) out[m] = fresh;
  }
  return out;
};

const channelPhrase = (items) => {
  const chans = [...new Set(items.map((c) => c.channel))];
  return chans.length === 1 ? `${channelMeta(chans[0]).label} ` : "";
};

const listChannels = (items) => {
  const labels = [...new Set(items.map((c) => channelMeta(c.channel).label))];
  if (labels.length <= 1) return labels.join("");
  return `${labels.slice(0, -1).join(", ")} and ${labels[labels.length - 1]}`;
};

export const spikeSentence = ({ month, pct, launches = [], running = [], clientName }) => {
  const lead = `Visits jumped ${Math.round(pct)}% in ${monthName(month)}`;
  if (launches.length) {
    return `${lead}, the same month ${launches.length} new ${channelPhrase(launches)}${launches.length === 1 ? "campaign" : "campaigns"} launched.`;
  }
  if (running.length) {
    return `${lead}, while ${plural(running.length, "paid campaign")} on ${listChannels(running)} kept ${clientName} in front of people.`;
  }
  return `${lead}, a sign that word about ${clientName} is spreading.`;
};
